import { Injectable, inject } from '@angular/core';
import { IHeader } from '@effy-tech/acquisition-core/header';
import { THEME, WebsiteThemes } from '@effy-tech/acquisition-core/shared';
import { EffyEnvironment } from '@effy-tech/angular-common/environment';
import { EffySite } from '@effy-tech/angular-common/site';
import { ERRORS_DATA, ErrorsData } from '../../components/not-found/error-model';
import { IQueriesId, QUERIES_ID } from '../../graphql/queries-id';
import { EnvironmentModel } from '../../interfaces/environment.interface';
import { ILogo } from '../../interfaces/logo';
import { BoUrlService } from '../../services/bo-url/bo-url.service';
import { ENVIRONMENT_DATA, HEADER_DATA, SITE } from './config.token';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly environments = inject<EnvironmentModel>(ENVIRONMENT_DATA, { optional: true });
  private readonly headerData = inject<IHeader>(HEADER_DATA, { optional: true });
  private readonly errorsData = inject<ErrorsData>(ERRORS_DATA, { optional: true });
  private theme = inject(THEME, { optional: true });
  private readonly site = inject(SITE, { optional: true });
  private readonly queriesId = inject<IQueriesId>(QUERIES_ID, { optional: true });

  environment: EnvironmentModel;

  // Id query to change when a new graphql version have been created (#idquery-effy-back on slack)
  private readonly ID_QUERY_VERSION = '622bcfc089da97922c2da4ffa79f0ffbd0153630';

  initConfig(): void {
    BoUrlService.setEnvironments(this.getEnvironment());
  }

  getTheme(): WebsiteThemes {
    return this.theme;
  }

  getSite(): EffySite {
    return this.site;
  }

  getQueriesId(): IQueriesId {
    return this.queriesId;
  }

  getEnvironment(): EnvironmentModel {
    return this.environments;
  }

  getHeaderData(): IHeader {
    return this.headerData;
  }

  getErrorsData(): ErrorsData {
    return this.errorsData;
  }

  getLogo(): ILogo {
    return this.getEnvironment().logo;
  }

  getEnv(): EffyEnvironment {
    return this.environments?.env ?? EffyEnvironment.Dev;
  }

  getQueryVersionId(): string {
    return this.ID_QUERY_VERSION;
  }

  getNewsletterApiUrl(baseUrl = this.environments.ecGatewayNginx, apiKey = this.environments.apiKey): string {
    const url = new URL(`/api/compose/v1/email-subscriptions`, baseUrl);
    url.searchParams.append('key', apiKey);
    return url.toString();
  }
}
